import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface ILoginSelector {
  readonly id: string;
  readonly type: MESSAGES.LOGIN_SELECTOR;
  readonly avatar: boolean;
  readonly role: ROLE.BOT;
  readonly rm?: boolean;
}

export const createLoginSelector = (data): ILoginSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.LOGIN_SELECTOR,
  avatar: true,
  role: ROLE.BOT,
  rm: true,
});
